<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div
        class="card bg-secondary shadow border-0 vld-parent"
        ref="formContainer"
      >
        <div class="card-header bg-transparent pb-4 pt-4">
          <img
            class="mx-auto d-block img-fluid"
            width="30%"
            src="/img/brand/logo_stars_black.png"
          />
        </div>
        <base-progress
          type="warning"
          :striped="true"
          :height="4"
          :showPercentage="false"
          :value="percentage"
        />
        <div class="card-body px-lg-5 py-lg-4">
          <form role="form" @submit="handleSignUp">
            <div v-show="step == 1">
              <div class="text-center text-muted mb-4">
                <p>Selecione uma opção:</p>
              </div>
              <div class="row">
                <div class="col-lg-12 mb-3">
                  <div
                    class="card bg-secondary shadow border-0"
                    :class="{ 'bg-default': isStartup }"
                  >
                    <div
                      class="btn card-body py-4"
                      style="cursor: pointer"
                      @click="model.type = 'startup'"
                    >
                      <span :class="{ 'text-orange': isStartup }"
                        >Tenho uma</span
                      >
                      <br />
                      <span :class="[isStartup ? 'text-white' : 'text-orange']"
                        >Startup</span
                      >
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 mb-3">
                  <div
                    class="card bg-secondary shadow border-0"
                    :class="{ 'bg-default': isInvestor }"
                  >
                    <div
                      class="btn card-body py-4"
                      style="cursor: pointer"
                      @click="model.type = 'investor'"
                    >
                      <span :class="{ 'text-orange': isInvestor }">Sou um</span>
                      <br />
                      <span :class="[isInvestor ? 'text-white' : 'text-orange']"
                        >Investidor</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="step == 2">
              <div class="text-center text-muted mb-4">
                <small>Informações da conta</small>
              </div>
              <base-input
                class="input-group-alternative mb-3"
                placeholder="Email"
                addon-left-icon="ni ni-email-83"
                v-model="model.email"
              >
              </base-input>
              <base-input
                class="input-group-alternative"
                placeholder="Senha"
                type="password"
                addon-left-icon="ni ni-lock-circle-open"
                v-model="model.password"
              >
              </base-input>
              <div v-if="model.password.length" class="text-muted font-italic">
                <small
                  >segurança da senha:
                  <span class="font-weight-700" :class="passwordStatus.class">{{
                    passwordStatus.message
                  }}</span></small
                >
              </div>
              <div class="row my-4">
                <div class="col-12">
                  <base-checkbox
                    class="custom-control-alternative d-inline"
                    v-model="model.agreeWithPrivacyPolicy"
                  >
                  </base-checkbox>
                  <span class="text-sm text-muted"
                    >Eu concordo com a
                    <span
                      class="btn-link font-weight-normal pointer"
                      @click="handleOpenModalPrivacyPolicy()"
                      >Política de Privacidade</span
                    ></span
                  >
                </div>
              </div>
              <base-alert
                type="danger"
                class="text-center mt-3 mb-0"
                v-if="error"
                ><i class="fas fa-exclamation-circle mr-1"></i>
                {{ error }}</base-alert
              >
            </div>
            <div class="row" v-if="model.type">
              <div class="col-lg-12">
                <base-button
                  type="default"
                  class="mt-3"
                  :btn-icon-only="true"
                  icon="ni ni-bold-left"
                  @click="previousStep"
                  v-show="step > 1"
                />
                <base-button
                  type="default"
                  class="mt-3 float-right"
                  :btn-icon-only="true"
                  icon="ni ni-bold-right"
                  @click="nextStep"
                  v-if="step < 2"
                />
                <base-button
                  v-else
                  nativeType="submit"
                  type="warning"
                  class="mt-3 float-right"
                  >Criar uma conta
                </base-button>
              </div>
            </div>
            <div v-else class="my-4"></div>
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <router-link to="/login" class="text-light">
            <small>Já tenho uma conta</small>
          </router-link>
        </div>
        <div class="col-6 text-right">
          <router-link to="/forgot-password" class="text-light">
            <small>Esqueceu sua senha?</small>
          </router-link>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modalPrivacyPolicy"
      modal-classes="modal-dialog-centered"
      headerClasses="pb-1"
      bodyClasses="pb-1"
      :scroll="true"
    >
      <h6 slot="header" class="modal-title">Política de Privacidade</h6>
      <div class="pt-3 text-center">
        <i class="fa fa-info-circle fa-3x"></i>
        <h4 class="heading mt-4">Portal Stars</h4>
        <p>Política de Privacidade</p>
      </div>
      <template>
        <ul class="text-sm policy-list">
          <li>
            Todas as suas informações pessoais recolhidas, serão usadas para o
            ajudar a tornar a sua visita no nosso site o mais produtiva e
            agradável possível;
          </li>
          <li>
            A garantia da confidencialidade dos dados pessoais dos utilizadores
            do nosso site é importante para a
            <a href="https://starsaceleradora.com.br/" target="_blank"
              >Stars Aceleradora</a
            >;
          </li>
          <li>
            Todas as informações pessoais relativas a membros, assinantes,
            clientes ou visitantes que usem o Portal Stars serão tratadas em
            concordância com a Lei da Proteção de Dados Pessoais de 26 de
            outubro de 1998 (Lei n.º 67/98);
          </li>
          <li>
            A informação pessoal recolhida pode incluir o seu nome, e-mail,
            número de telefone e/ou telemóvel, morada, data de nascimento e/ou
            outros;
          </li>
          <li>
            Utilizamos cookies para armazenar informação, tais como as suas
            preferências pessoas quando visita o nosso website. Isto poderá
            incluir um simples popup ou preferências de navegação;
          </li>
          <li>
            Você detém o poder de desligar os seus cookies, nas opções do seu
            browser. No entanto, isso poderá alterar a forma como interage com o
            nosso website, ou outros websites;
          </li>
          <li>
            O uso do Portal Stars pressupõe a aceitação deste acordo de
            privacidade. A equipe da
            <a href="https://starsaceleradora.com.br/" target="_blank">Stars</a>
            reserva-se ao direito de alterar este acordo sem aviso prévio. Deste
            modo, recomendamos que consulte a nossa política de privacidade com
            regularidade de forma a estar sempre atualizado.
          </li>
        </ul>
        <p class="px-4 text-center">
          Para obter informações sobre como entrar em contato com o Stars, por
          favor, visite nosso
          <a href="https://starsaceleradora.com.br/" target="_blank">website</a
          >.
        </p>
      </template>

      <template slot="footer">
        <base-button
          type="link"
          class="ml-auto"
          @click="modalPrivacyPolicy = false"
        >
          Fechar
        </base-button>
      </template>
    </modal>

    <modal
      :show.sync="modalNextSteps"
      modal-classes="modal-default modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation">
        <div class="py-3 text-center">
          <i class="fa fa-check-circle fa-3x"></i>
          <h4 class="heading mt-4">Conta criada com sucesso!</h4>
          <p class="mt-3">
            Agora, você precisa <b>fazer login</b> para
            <b>concluir o seu cadastro</b>. Você também recebeu <b>um e-mail</b>
            contendo próximos passos e outras informações úteis.
          </p>
          <p class="mt-2 mb-0">
            Ao clicar no botão abaixo, você será redirecionado à
            <b>página de login</b>.
          </p>
        </div>
      </div>
      <template slot="footer">
        <div class="text-center">
          <base-button type="white text-success" @click="$router.push('/')">
            Ir para a página de login
          </base-button>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "../services/api";

export default {
  name: "register",
  data() {
    return {
      model: {
        email: "",
        password: "",
        type: "",
        agreeWithPrivacyPolicy: false,
      },
      error: "",
      percentage: 0,
      step: 1,
      modalPrivacyPolicy: false,
      modalNextSteps: false,
    };
  },
  mounted() {
    window.fbq("track", "PageView");
    const type = this.$route.query.t;
    if (type === "startup" || type === "investor") this.model.type = type;
  },
  methods: {
    async handleSignUp(e) {
      e.preventDefault();
      this.error = "";
      const user = this.model;
      user.email = user.email.trim();
      if (!user.email || !user.password || !user.type) {
        this.error = "Preencha todos os dados para se cadastrar.";
        return;
      } else if (!user.agreeWithPrivacyPolicy) {
        this.error =
          "Você precisa concordar com a nossa Política de Privacidade.";
        return;
      }
      const loader = this.$loading.show({
        container: this.$refs.formContainer,
        width: 128,
        height: 128,
      });
      try {
        await api.post("/users", user);
        this.percentage += 50;
        this.$toasted.success(
          "Conta criada com sucesso! Efetue o login para concluir o seu cadastro."
        );
        this.modalNextSteps = true;
      } catch (e) {
        const genericError = "Ocorreu um erro ao registar sua conta.";
        const hasErrorResponseData = e.response && e.response.data;
        let customError = genericError;
        if (hasErrorResponseData) {
          const data = e.response.data;
          if (data[0] && data[0].message) customError = data[0].message;
          else if (data.message) customError = data.message;
        }
        this.error = hasErrorResponseData ? customError : genericError;
        this.$toasted.error(genericError);
      } finally {
        loader.hide();
      }
    },
    nextStep(e) {
      e.preventDefault();
      this.step++;
      this.percentage += 50;
    },
    previousStep(e) {
      e.preventDefault();
      this.step--;
      this.percentage -= 50;
    },
    handleOpenModalPrivacyPolicy() {
      this.modalPrivacyPolicy = true;
    },
  },
  computed: {
    passwordStatus: function () {
      const status = {
        strong: {
          class: "text-success",
          message: "forte",
        },
        average: {
          class: "text-warning",
          message: "média",
        },
        weak: {
          class: "text-danger",
          message: "fraca",
        },
      };
      const length = this.model.password.length;
      return length < 6
        ? status.weak
        : length < 10
        ? status.average
        : status.strong;
    },
    isStartup() {
      return this.model.type == "startup";
    },
    isInvestor() {
      return this.model.type == "investor";
    },
  },
};
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
.policy-list li {
  margin-bottom: 7px;
}
</style>
